/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-row[_ngcontent-%COMP%]{cursor:pointer!important}div.d-flex[_ngcontent-%COMP%]{width:100%}.table-sdw.is-fixed[_ngcontent-%COMP%]{margin-left:5px}"];
export { styles as styles };
